import { Box, Button, Typography } from '@mui/material'
import React from 'react'

const ServiceTypesHeader = ({btnOnClick}) => {
  return (
     <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body1">Print Color Types</Typography>
        <Button variant="contained" size="small" onClick={btnOnClick}>
          Add Service Type
        </Button>
      </Box>
  )
}

export default ServiceTypesHeader